export default "__VITE_ASSET__04fbb8e2__"